// extracted by mini-css-extract-plugin
export default {"content":"CartLogin_content__as1k8","realContent":"CartLogin_realContent__bKKdo"};